import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Modifier, EditorState } from "draft-js";
import { Map } from "immutable";

import Button from "components/library/Button";
import Popover from "components/library/Popover";
import getActiveEditorState from "editor/utils/getActiveEditorState";
import { updateActiveEditor } from "editor/actions/form";
import { removeCustomBlock } from "editor/actions/blocks";
import { EDITOR_MODALS } from "config/constants/editor";

import shared from "../../../shared.css";
import styles from "./EmbedPopover.css";

// TODO: Convert EmbedPopover to a function component so that we can reuse the
// matchMedia hook in PrimaryImagePopover.
class EmbedPopover extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isSmall: null,
    };

    this.calculateOffset = this._calculateOffset.bind(this);
    this.handleDelete = this._handleDelete.bind(this);
    this.handleOpenNewTab = this._handleOpenNewTab.bind(this);
    this.handleMatchMedia = this._handleMatchMedia.bind(this);
    this.match = null;
  }

  componentDidMount() {
    this.match = window.matchMedia(shared["breakpoint-small"]);
    this.match.addListener(this.handleMatchMedia);
  }

  componentWillUnmount() {
    this.match.removeListener(this.handleMatchMedia);
  }

  _calculateOffset() {
    if (!this.props.embedEl || !this.props.isActive) {
      return;
    }

    let {
      top: embedTop,
      width: embedWidth,
    } = this.props.embedEl.getBoundingClientRect();

    embedTop = `${embedTop / 10}rem`;

    return {
      top: this.state.isSmall
        ? `calc(${embedTop} + ${shared["scale-4"]})`
        : embedTop,
      left: this.state.isSmall
        ? `calc(${(document.documentElement.clientWidth / 2 - embedWidth / 2) /
            10}rem + ${shared["scale-4"]})`
        : `calc(${(document.documentElement.clientWidth / 2 + embedWidth / 2) /
            10}rem + ${shared["scale-6"]})`,
    };
  }

  _handleDelete(e) {
    e.preventDefault();
    this.props.removeCustomBlock(this.props.blockKey);
    // facebook embeds all have an id of fb-root (which is dumb)
    const onlyEmbed = document.querySelectorAll("#fb-root");

    if (onlyEmbed.length === 1) {
      delete window.FB;
      const fbJs = document.querySelector(".fb-embed-lib");
      if (fbJs) fbJs.remove();
    }
  }

  _handleOpenNewTab(e) {
    e.preventDefault();
    const { url } = this.props.embedData;
    window.open(url, "_blank");
  }

  updateEmbedBlockData(newEmbedData) {
    const contentState = this.props.editorState.getCurrentContent();
    const selectionState = this.props.editorState.getSelection();
    const newContentState = Modifier.mergeBlockData(
      contentState,
      selectionState,
      Map(newEmbedData)
    );
    this.props.updateActiveEditor(
      EditorState.push(
        this.props.editorState,
        newContentState,
        "change-block-data"
      )
    );
  }

  isActive() {
    return this.props.isActive && this.props.openModal !== EDITOR_MODALS.LINK;
  }

  _handleMatchMedia(e) {
    this.setState({ isSmall: !e.matches });
  }

  render() {
    return (
      <Popover
        blockKey={this.props.blockKey}
        isOpened={this.isActive()}
        position={this.calculateOffset()}
        className={styles.root}
        closeModal={this.props.closeModal}
      >
        <div className={styles.buttonGroup}>
          <Button
            className="qa-embedPopoverOpen"
            onClick={this.handleOpenNewTab}
            type="tertiary"
          >
            Open in new tab
          </Button>
          <Button
            className="qa-embedPopoverDelete"
            destructive
            onClick={this.handleDelete}
            type="tertiary"
          >
            Delete embed
          </Button>
        </div>
      </Popover>
    );
  }
}

const mapStateToProps = state => {
  return {
    editorState: getActiveEditorState(state),
    openModal: state.editor.ui.openModal,
  };
};

const mapDispatchToProps = {
  updateActiveEditor,
  removeCustomBlock,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmbedPopover);

EmbedPopover.propTypes = {
  blockKey: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  editorState: PropTypes.object.isRequired,
  embedData: PropTypes.object.isRequired,
  embedEl: PropTypes.instanceOf(Element),
  removeCustomBlock: PropTypes.func.isRequired,
  updateActiveEditor: PropTypes.func.isRequired,
};
